import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PaginatedResponse } from '@tamwely-types/common';
import { CustomerLoanRequest, CustomerLoanResponse } from '../types/customer-dashboard';
import {
  AdvisorLoanRequestResponse,
  AdvisorRequestsParams,
  CreateLoanRequest,
} from '../types/loan';

const LoanEndpoints = {
  CREATE: 'api/v1/loans',
  GET_ADVISOR_REQUESTS: 'api/v1/loans/advisor',
  GET_CUSTOMER_REQUESTS: 'api/v1/loans/customer',
  GET_CUSTOMER_LOAN_DETAILS: (loanId: number) => `api/v1/loans/customer/${loanId}`,
};

@Injectable({
  providedIn: 'root',
})
export class LoanService {
  private readonly httpClient = inject(HttpClient);

  createLoanRequest(request: CreateLoanRequest) {
    return this.httpClient.post<void>(LoanEndpoints.CREATE, request);
  }

  getLoanRequestsForCustomer() {
    return this.httpClient.get<CustomerLoanRequest[]>(LoanEndpoints.GET_CUSTOMER_REQUESTS);
  }

  getCustomerLoanDetails(loanId: number) {
    return this.httpClient.get<CustomerLoanResponse>(
      LoanEndpoints.GET_CUSTOMER_LOAN_DETAILS(loanId)
    );
  }

  getLoanRequestsForAdvisor(params: AdvisorRequestsParams) {
    const { page, size, ...filters } = params;
    let httpParams = new HttpParams().set('page', page).set('size', size);

    Object.entries(filters).forEach(([key, value]) => {
      if (value != null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });

    return this.httpClient.get<PaginatedResponse<AdvisorLoanRequestResponse>>(
      LoanEndpoints.GET_ADVISOR_REQUESTS,
      { params: httpParams }
    );
  }
}
